module.exports = __webpack_public_path__ + "img/car_icon.e6280841.png";